import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './Layout.css';

function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="nav">
        <div className="nav-inner">
          <NavLink to="/" className="nav-logo" onClick={closeMenu}>Voxale</NavLink>
          <div className="nav-links">
            <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} end>Home</NavLink>
            <NavLink to="/news" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>News</NavLink>
            <NavLink to="/rules" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Rules</NavLink>
            <NavLink to="/vote" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Vote</NavLink>
            <NavLink to="/store" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Store</NavLink>
            <NavLink to="/staff" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Staff</NavLink>
          </div>
          <button className="nav-toggle" onClick={toggleMenu}>☰</button>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <NavLink to="/" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu} end>Home</NavLink>
        <NavLink to="/news" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu}>News</NavLink>
        <NavLink to="/rules" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu}>Rules</NavLink>
        <NavLink to="/vote" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu}>Vote</NavLink>
        <NavLink to="/store" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu}>Store</NavLink>
        <NavLink to="/staff" className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`} onClick={closeMenu}>Staff</NavLink>
      </div>

      <main className="main-content">
        <Outlet />
      </main>
    </>
  );
}

export default Layout;
